import { ref } from 'vue';

/**
 * 全局常驻 widget 注册表（PC 壳）。
 *
 * 插件 remote 在 setup(hostCtx) 时经 hostCtx.registerWidget 注入
 * { id, component }；MainLayout 通过 <GlobalWidgets/> 渲染在 router-view
 * 之外——切页面不卸载（流式对话等长生命周期状态存活）。
 *
 * 与 addNav 同构：插件未启用/加载失败时其 widget 自然不存在，无需特判。
 */
export const widgetRegistry = ref([]); // [{ id, component }]

export function registerWidget(w) {
  if (!w?.id || !w?.component) return;
  // 幂等：同 id 顶替（loadPlugins 重跑场景）
  const i = widgetRegistry.value.findIndex(x => x.id === w.id);
  if (i >= 0) widgetRegistry.value[i] = w;
  else widgetRegistry.value.push(w);
}
